<template>
  <EInstantAnswer
    data-test-id="mental-health"
    :feedback-link="{ ticketSubject: 'Search - Mental Health' }"
    :sources="sources"
    powered-by-ecosia
  >
    <template #context>
      {{ context }}
    </template>
    <template #title>
      <ELink
        data-test-id="phone-link"
        :href="phoneLink"
        target="_blank"
        color="dark"
        rel="noopener"
      >
        <span class="sr-only" data-test-id="phone-number">{{ srText }}</span> {{ phoneNumber }}
      </ELink>
    </template>
    <template #subtitle>
      <div data-test-id="subtitle">
        {{ subtitle }}
      </div>
      <EDivider class="divider" aria-hidden="true" />
    </template>
    <template #default>
      <div class="mental-health-body__title" data-test-id="body-title">
        {{ bodyTitle }}
      </div>
      <div class="mental-health__body" data-test-id="body">
        {{ body }}
      </div>
      <div class="links">
        <ELinkBubble
          data-test-id="contact-link"
          :href="contactLink"
          :target="linkTarget"
          rel="noopener"
          color="result"
          class="mental-health__link"
          @click="onLinkClick"
        >
          <EIcon :icon="icon" size="s" />
          {{ linkText }}
        </ELinkBubble>
      </div>
    </template>
  </EInstantAnswer>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { sourceTitles, sourceURLs, subtitles,
  phoneLinks, phoneNumbers, bodyTitles, bodies, contexts, contactLinks, icons, linkTexts, srTexts } from './copy';
import EIcon from '~~/common/vue/components/icon';
import { trackImpression, trackClick, PAGE_SERP, TYPE_RICH } from '~~/search/common/js/client/analytics/rich-content';
import EInstantAnswer from '~/components/instant-answers/base';
import ELinkBubble from '~~/common/vue/components/link-bubble';
import EDivider from '~~/common/vue/components/divider/index';
import ELink from '~~/common/vue/components/link';

export const TRACK_ID = 'mental_health';

export default {
  name: 'EMentalHealthNotice',
  components: {
    EInstantAnswer,
    ELinkBubble,
    EDivider,
    EIcon,
    ELink,
  },
  computed: {
    ...mapGetters('user', ['linkTarget']),
    ...mapState('user', ['bingMarketCode']),
    sources() {
      const title = sourceTitles[this.bingMarketCode] || sourceTitles['en-gb'];
      const url = sourceURLs[this.bingMarketCode] || sourceURLs['en-gb'];
      return [
        { title, url },
      ];
    },
    subtitle() {
      return subtitles[this.bingMarketCode] || subtitles['en-gb'];
    },
    phoneLink() {
      return phoneLinks[this.bingMarketCode] || phoneLinks['en-gb'];
    },
    phoneNumber() {
      return phoneNumbers[this.bingMarketCode] || phoneNumbers['en-gb'];
    },
    srText() {
      return srTexts[this.bingMarketCode] || srTexts['en-gb'];
    },
    bodyTitle() {
      return bodyTitles[this.bingMarketCode] || '';
    },
    body() {
      return bodies[this.bingMarketCode] || '';
    },
    context() {
      return contexts[this.bingMarketCode] || '';
    },
    contactLink() {
      return contactLinks[this.bingMarketCode] || contactLinks['en-gb'];
    },
    icon() {
      return icons[this.bingMarketCode] || icons['en-gb'];
    },
    linkText() {
      return linkTexts[this.bingMarketCode] || linkTexts['en-gb'];
    },
  },
  mounted() {
    trackImpression({
      name: TRACK_ID,
      page: PAGE_SERP,
      type: TYPE_RICH,
    });
  },
  methods: {
    onLinkClick: trackClick({
      name: TRACK_ID,
      type: TYPE_RICH,
      target: 'contact-link',
    }),
  },
};

</script>

<style lang="scss" scoped>

.divider {
  margin: $space-m 0;
}

.mental-health-body__title {
  margin-bottom: $space-s;
  font-size: $font-l;
  color: var(--color-text-secondary);
}

.mental-health__body {
  margin-bottom: $space-m;
}

.links {
  display: flex;
}

.mental-health__link {
  font-size: $font-m;
  gap: $space-1s;
}

</style>
